module.exports = __webpack_public_path__ + "img/slogan.0189aaea.png";